import { User, UserWidgetsState, CaseBaseModel } from 'models';

import { TaskWidgetContainer } from 'containers';
import { Box, useTheme } from '@material-ui/core';
import {
  PageTitle,
  PageLoader,
  Error,
  WelcomeWidget,
  CaseWidget,
  ReservationWidget,
  CaseCreatorWidget,
  ContactInformationWidget,
  MessageWidget,
  FinanceWidget,
  SituationWidget,
  WidgetBox,
  CooperativeBudgetWidget,
} from 'components';

import { useStyles } from './style';

function getWidgetStatus<T extends {}>(obj: T) {
  return Object.values(obj).some((key) => !!key);
}

interface Props {
  userSettings: User | null;
  userWidgets: UserWidgetsState;
  loading: boolean;
  error: boolean;
  showWelcomeWidget: boolean;
  initWelcomeWidget: () => void;
  handleChangeBaseCase: (newBaseCase: CaseBaseModel) => void;
}

const MainPageDetails: React.FC<Props> = ({
  userSettings,
  userWidgets,
  loading,
  error,
  showWelcomeWidget,
  initWelcomeWidget,
  handleChangeBaseCase,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  if (error) return <Error />;
  if (loading) return <PageLoader />;

  const showContactInformationWidget = getWidgetStatus(
    userWidgets.ContactInformationWidget
  );

  return (
    <>
      <Box display="flex" alignItems="center" marginBottom="20px">
        <PageTitle className={classes.title}>
          {`Tervetuloa, ${userSettings?.FirstName}!`}
        </PageTitle>
        {userWidgets.NewButtonWidget ? (
          <Box marginLeft="20px">
            <CaseCreatorWidget
              defaultWidgetData={userWidgets.NewButtonWidget}
            />
          </Box>
        ) : null}
      </Box>
      <div className={classes.container}>
        {userWidgets.WelcomeWidget && showWelcomeWidget ? (
          <Box marginBottom="20px">
            <WelcomeWidget
              welcomWidgetData={userWidgets.WelcomeWidget}
              initWelcomeWidget={initWelcomeWidget}
            />
          </Box>
        ) : null}
        <Box
          display="flex"
          flexWrap="wrap"
          style={{ gap: theme.size.widgetGap }}
        >
          {userWidgets.CaseWidget && (
            <WidgetBox>
              <CaseWidget
                baseCases={userWidgets.CaseWidget}
                handleChangeBaseCase={handleChangeBaseCase}
              />
            </WidgetBox>
          )}
          {userWidgets.ReservationWidget && (
            <WidgetBox>
              <ReservationWidget />
            </WidgetBox>
          )}
          {userWidgets.MessageWidget && (
            <WidgetBox>
              <MessageWidget messages={userWidgets.MessageWidget} />
            </WidgetBox>
          )}
          {userWidgets.TaskWidget && (
            <WidgetBox>
              <TaskWidgetContainer defaultTasks={userWidgets.TaskWidget} />
            </WidgetBox>
          )}
          {userWidgets.FinanceWidget && (
            <WidgetBox>
              <FinanceWidget
                totalBalance={userWidgets.FinanceWidget.TotalBalance}
              />
            </WidgetBox>
          )}
          {userWidgets.CooperativeBalanceSituationWidget && (
            <WidgetBox>
              <SituationWidget
                cooperativeBalances={
                  userWidgets.CooperativeBalanceSituationWidget
                }
              />
            </WidgetBox>
          )}
          {userWidgets.CooperativeBudgetWidget && (
            <WidgetBox>
              <CooperativeBudgetWidget
                budget={userWidgets.CooperativeBudgetWidget}
              />
            </WidgetBox>
          )}
        </Box>
        {showContactInformationWidget && (
          <Box display="flex" flexBasis="100%" marginTop="20px">
            <ContactInformationWidget
              widgetData={userWidgets.ContactInformationWidget}
            />
          </Box>
        )}
      </div>
    </>
  );
};

export default MainPageDetails;
